import React from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"

import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../../../components/Typograph"
import DescriptionList from "../../../../../../components/DescriptionList"

import { showToast } from "../../../../../../components/Toast"

import styles from "./styles.css"

import { formatRequestDetails } from "../../utils"

import Done from "../../../../../../assets/svg/done.svg"

const RequestDetailsModal = ({
  isOpen,
  onCloseModal,
  requestProtocol,
  requestDetails
}) => {
  const formatDetails = formatRequestDetails(requestDetails)

  function handleOnConfirm() {
    showToast({
      message: `<p>Cliente, sua solicitação foi enviada com sucesso!</p> <p>Número de protocolo: <b>${requestProtocol}</b> </p?`,
      acceptHtml: true,
      type: "sucess"
    })
    onCloseModal()
  }

  return (
    <ModernModal
      isOpen={isOpen}
      confirmButtonText="Finalizar"
      removeButton
      onClose={onCloseModal}
      onConfirm={handleOnConfirm}
    >
      <div className={styles.doneIcon}>
        <img src={Done} alt="Finalizado" />
      </div>
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        Sua solicitação de áudio foi enviada com sucesso!
      </Typograph>
      <Typograph htmlTag="p" size="medium" color="outer_space" weight="medium">
        Sua solicitação será analisada pela equipe responsável e será respondida
        em até 10 dias. Você receberá um e-mail com a resposta no endereço de
        e-mail informado.
      </Typograph>

      <div className={styles.detailsContainer}>
        {_map(formatDetails, (item, index) => (
          <DescriptionList
            description={item.description}
            value={item.value}
            hasDivider
            last={item.last}
            key={`${item.value}-${index}`}
          />
        ))}
      </div>
    </ModernModal>
  )
}

RequestDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseModal: PropTypes.func,
  requestProtocol: PropTypes.string,
  requestDetails: PropTypes.object
}

export default RequestDetailsModal



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/AudioRequest/components/RequestDetailsModal/index.js